import {
  ColorProperty,
  FlexAnchor,
  FlexAnchorProps,
  HelpLinkIFrame,
  Icon,
  IconProperty,
  IconsTheme,
  ModalHeader,
  smBumps,
  Typo,
  useModal,
} from '@wrisk/ui-components'
import React, { useCallback } from 'react'

import { ConditionalCover } from '../../../domain'
import {
  tCovers,
  TKey,
  useWriskTranslation,
} from '../../../infrastructure/internationalisation'

interface ConditionalCoverItemProps extends Omit<FlexAnchorProps, 'ref'> {
  conditionalCover: ConditionalCover
  iconSize?: IconProperty
  contentBaseUrl: string
}

const tKey = TKey('components.conditional-cover-item')

export const ConditionalCoverItem: React.FC<ConditionalCoverItemProps> = ({
  conditionalCover,
  contentBaseUrl,
  typoSize,
  iconSize,
  ...props
}) => {
  const { t } = useWriskTranslation()

  const modal = useModal()

  const onClick = useCallback(() => {
    conditionalCover.active
      ? modal.show({
          content: (
            <HelpLinkIFrame
              src={`${contentBaseUrl}/${conditionalCover.coverCode}.html`}
            />
          ),
          variant: 'iframe',
        })
      : modal.show({
          content: (
            <ModalHeader
              header={t(tKey('unavailable', 'header'))}
              subheader={t(tKey('unavailable', 'content'))}
            />
          ),
        })
  }, [contentBaseUrl, conditionalCover, modal])

  const { icon, color }: { icon: keyof IconsTheme; color: ColorProperty } =
    conditionalCover.active
      ? {
          icon: 'tick',
          color: 'body',
        }
      : {
          icon: 'cross',
          color: 'bodySecondary',
        }

  return (
    <FlexAnchor
      variant='highlight'
      justifyContent='flex-start'
      py={3}
      px={smBumps}
      onClick={onClick}
      {...props}
    >
      <Icon icon={icon} color={color} mr={smBumps} size={iconSize ?? 'medium'} />
      <Typo wordWrap='break-word' typoSize={typoSize} color={color}>
        {t(tCovers(conditionalCover.coverCode, 'name'))}
      </Typo>
    </FlexAnchor>
  )
}
